import { styled } from '@mui/material';
import { RoundedSquareIconButton } from '@/components/RoundedSquareIconButton';

export const TitleTextActionButton = styled(RoundedSquareIconButton)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  padding: '0px',
  marginLeft: '4px',
}));
